<template>
  <div>
    <v-tabs
      v-model="tab"
      :optional="route().current() === 'faq.question.edit' || route().current() === 'faq.create-question'"
      background-color="primary"
      dark
      flat
      fixed-tabs
      next-icon="mdi-chevron-right"
      prev-icon="mdi-chevron-left"
      show-arrows
      :slider-size="5"
      @change="handleTabChange"
    >
      <v-tabs-slider color="primary lighten-4" />
      <v-tab
        v-for="item in tabs"
        :key="item.value"
        :href="item.value"
      >
        {{ item.title }}
      </v-tab>
    </v-tabs>

    <div
      v-if="! forceHidePreview"
      class="d-flex justify-end grey lighten-4 mb-3 px-2"
    >
      <v-switch
        v-model="$root.preview.faq.show"
        class="mt-2 mb-2 mr-3"
        hide-details
        dense
        inset
        label="Live FAQ Preview"
      />
    </div>

    <v-container
      fluid
      :class="{'pt-0': ! forceHidePreview}"
    >
      <portal-target name="flash" />

      <v-row>
        <v-col
          cols="12"
          :md="$root.preview.faq.show && ! forceHidePreview ? 7 : 12"
        >
          <slot />
        </v-col>
        <v-col
          v-if="$root.preview.faq.show && ! forceHidePreview"
          cols="12"
          md="5"
        >
          <preview
            :faq-id="faq.slug"
            :languages="faq.available_languages"
            :default-language="faq.default_language"
            :portal-url="faq.portal_url"
            :portal-enabled="faq.portal_enabled"
            :portal-passwords-enabled="faq.portal_passwords_enabled"
          />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import Preview from '@/components/faq/Preview';
import i18n from '@/plugins/vue-i18n';

export default {
  components: {
    Preview
  },

  provide() {
    return {
      mainLayout: this
    }
  },

  props: {
    faq: {
      type: Object,
      required: true
    },
    activeTab: {
      type: String,
      required: false,
      default: null
    },
    forceHidePreview: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      tab: this.activeTab,
    }
  },

  computed: {
    tabs() {
      return [
        {
          title: i18n.t('Overview'),
          value: '#overview',
          href: this.route('faq.overview', this.faq.id)
        },
        {
          title: i18n.t('Questions'),
          value: '#manage',
          href: this.route('faq.manage', this.faq.id)
        },
        {
          title: i18n.t('Translate'),
          value: '#translations',
          href: this.route('faq.translate', this.faq.id)
        },
        {
          title: i18n.t('Settings'),
          value: '#settings',
          href: this.route('faq-settings.general', this.faq.id)
        },
        {
          title: i18n.t('Publish'),
          value: '#publish',
          href: this.route('faq.publish', this.faq.id)
        }
      ]
    },
  },

  watch: {
    activeTab: function(value) {
      this.tab = value;
    }
  },

  created() {
    window.eventBus.$on('faq.main-layout:set-tab', tabName => {
      this.$nextTick(() => {
        this.tab = tabName;
      });
    });
  },

  methods: {
    handleTabChange(value) {
      const tab = this.tabs.find(tab => tab.value === `#${value}`);

      this.$inertia.visit(tab.href);
    },
  }
}
</script>
